"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoresContainer = void 0;
const react_1 = __importDefault(require("react"));
const utils_1 = require("../../../utils");
const window_1 = require("../../../utils/window");
const index_1 = require("../../index");
const StoresContainer = (props) => {
    const { children, scope } = props;
    let initialConfigState;
    let initialModalState;
    let initialProductState;
    let initialSelectRegistryState;
    let initialShoppingPortalState;
    let initialWeblabState;
    if ((0, window_1.isServerSide)()) {
        utils_1.serverConsole.log('Get initial state from registry to initialize stores', scope);
        initialConfigState = index_1.registry.getStore(index_1.configStore, scope).getState();
        initialModalState = index_1.registry.getStore(index_1.modalStore, scope).getState();
        initialProductState = index_1.registry.getStore(index_1.productStore, scope).getState();
        initialSelectRegistryState = index_1.registry.getStore(index_1.selectRegistryStore, scope).getState();
        initialShoppingPortalState = index_1.registry.getStore(index_1.shoppingPortalStore, scope).getState();
        initialWeblabState = index_1.registry.getStore(index_1.weblabStore, scope).getState();
    }
    else {
        if (index_1.registry.stores.size === 0) {
            utils_1.serverConsole.log('Get initial state from InitialStateScript to initialize stores', scope);
            initialConfigState = (0, index_1.getInitialState)((0, index_1.getInitialStateName)(index_1.CONFIG_STORE_NAME));
            initialModalState = (0, index_1.getInitialState)((0, index_1.getInitialStateName)(index_1.MODAL_STORE_NAME));
            initialProductState = (0, index_1.getInitialState)((0, index_1.getInitialStateName)(index_1.PRODUCT_STORE_NAME));
            initialSelectRegistryState = (0, index_1.getInitialState)((0, index_1.getInitialStateName)(index_1.SELECT_STORE_NAME));
            initialShoppingPortalState = (0, index_1.getInitialState)((0, index_1.getInitialStateName)(index_1.SHOPPING_PORTAL_STORE_NAME));
            initialWeblabState = (0, index_1.getInitialState)((0, index_1.getInitialStateName)(index_1.WEBLAB_STORE_NAME));
        }
        else {
            initialConfigState = index_1.registry.getStore(index_1.configStore, scope).getState();
            initialModalState = index_1.registry.getStore(index_1.modalStore, scope).getState();
            initialProductState = index_1.registry.getStore(index_1.productStore, scope).getState();
            initialSelectRegistryState = index_1.registry.getStore(index_1.selectRegistryStore, scope).getState();
            initialShoppingPortalState = index_1.registry.getStore(index_1.shoppingPortalStore, scope).getState();
            initialWeblabState = index_1.registry.getStore(index_1.weblabStore, scope).getState();
        }
    }
    return (react_1.default.createElement(index_1.ConfigContainer, { initialState: initialConfigState },
        react_1.default.createElement(index_1.ShoppingPortalContainer, { initialState: initialShoppingPortalState },
            react_1.default.createElement(index_1.WeblabContainer, { initialState: initialWeblabState },
                react_1.default.createElement(index_1.ProductContainer, { initialState: initialProductState },
                    react_1.default.createElement(index_1.SelectContainer, { initialState: initialSelectRegistryState },
                        react_1.default.createElement(index_1.ModalContainer, { initialState: initialModalState }, children)))))));
};
exports.StoresContainer = StoresContainer;
